import { countries } from '@medflex/commons';

const useCountries = () => countries;

export default useCountries;
